const cikeOrgProtocol = () =>
  import(/* webpackChunkName: "orgProtocolCiKe" */ 'page/orgProtocol/ck.vue')

const routes = [
  {
    path: '/orgProtocol/ck',
    component: cikeOrgProtocol,
    meta: {
      pageName: '用户隐私协议',
      business: '此刻',
      openAppModalOnSelf: true
    }
  }
]

export default routes
